import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import cloudOptimizationHero from "../assets/Hero/cloud-optimization-hero.webp"; // Replace with your hero image
import cloudOptimizationImage from "../assets/Hero/Cloud-Optimization.jpg"; // Replace with your cloud optimization image
import "../assets/css/cloudOptimizationPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const cloudOptimizationData = {
  hero: {
    title: "Cloud Optimization",
    subtitle: "Maximize Efficiency and Performance in Your Cloud Environment",
  },
  introduction: {
    heading: "Why Cloud Optimization Matters",
    paragraphs: [
      "Cloud optimization ensures that your cloud resources are used efficiently, reducing costs and improving performance.",
      "Our cloud optimization solutions are designed to provide actionable insights, streamline workflows, and enhance scalability for your business.",
    ],
  },
  cta: {
    heading: "Ready to Optimize Your Cloud Environment?",
    text: "Contact us today to learn more about our Cloud Optimization Solutions and how we can help your business thrive.",
  },
};

export const CloudOptimizationPage = ({ data }) => {
  const cloudOptimizationRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = cloudOptimizationRef.current.querySelectorAll(".cloud-optimization-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: cloudOptimizationRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="cloud-optimization-page" ref={cloudOptimizationRef}>
      {/* Hero Section */}
      <div
        className="cloud-optimization-hero-section"
        style={{ backgroundImage: `url(${cloudOptimizationHero})` }}
      >
        <h1 className="cloud-optimization-animate">{cloudOptimizationData.hero.title}</h1>
        <p className="cloud-optimization-animate">{cloudOptimizationData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container cloud-optimization-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="cloud-optimization-animate">{cloudOptimizationData.introduction.heading}</h2>
            {cloudOptimizationData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="cloud-optimization-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 cloud-optimization-image-container">
            <img
              src={cloudOptimizationImage}
              className="img-fluid cloud-optimization-animate"
              alt="Cloud Optimization"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container cloud-optimization-cta">
        <h2 className="cloud-optimization-animate">{cloudOptimizationData.cta.heading}</h2>
        <p className="cloud-optimization-animate">{cloudOptimizationData.cta.text}</p>
        <button
          className="btn btn-primary cloud-optimization-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};